// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3UynU","colMaxWidth":"Table_colMaxWidth__2Lrxc"};